module.exports = __webpack_public_path__ + "img/refresh.8f075c1d.svg";